import React, { useEffect, useState } from 'react';
import SuperAdminHeader from "./Header";
import { toast } from 'react-toastify'; // Ensure react-toastify is installed and imported
import { api, superAdminReqConfig } from "../../include/api";


const NotificationHistory = () => {
    const [sentNotifications, setSentNotifications] = useState([]);
    const [saving, setSaving] = useState(false);
    const [formData, setFormData] = useState({ title: '', body: '', previewUrl: '', url: '' });

    useEffect(() => {
        const notifications = JSON.parse(localStorage.getItem('notifications')) || [];
        setSentNotifications(notifications);
    }, []);

    // Add this function to handle deletion
    const handleDelete = (index) => {
        const updated = sentNotifications.filter((_, i) => i !== index);
        setSentNotifications(updated);
        localStorage.setItem('notifications', JSON.stringify(updated));
    };

    const sendNotification = () => {
        const dataToSend = {
            title: formData.title,
            body: formData.body,
            image_url: formData.previewUrl,
            click_url: formData.clickUrl, // Include url in dataToSend if needed by backend

        };

        const superAdminReqConfig = () => ({
            headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`, // Example token handling
            },
        });

        setSaving(true);

        api.post("/notification/", dataToSend, superAdminReqConfig())
            .then((response) => {
                if (response.status === 200) {
                    toast.success("Notification sent successfully!");
                const newNotification = {
                            title: formData.title,
                            body: formData.body,
                            image: formData.previewUrl,
                            clickUrl: formData.clickUrl, // Store url in notification
                            dateTime: new Date().toLocaleString(),
                        };
                setSentNotifications((prev) => {
                    const updated = [...prev, newNotification];
                    localStorage.setItem('notifications', JSON.stringify(updated)); // Save to localStorage
                    return updated;
                });
                    // Save notification to localStorage
                clearFields();
            }
        })
            .catch((error) => {
                if (error.response) {
                    toast.error(error.response.data.message || "Something went wrong");
                } else {
                    toast.error(error.message || "Network error");
                }
            })
            .finally(() => setSaving(false));
    };

    const clearFields = () => {
        setFormData({ title: '', body: '', previewUrl: '', clickUrl: '' });
    };

    return (
        <SuperAdminHeader>
            <div className="fixed-top-bar">
                <div className="m-4">
                    <h3 className='fs-2'>Notifications History</h3>
                    <table className="table mb-5">
                        <thead>
                            <tr>
                                <th>Title</th>
                                <th>Body</th>
                                <th>Image</th>
                                <th>URL</th>
                                <th>Date & Time</th>
                                <th>Action</th> {/* Add Action column */}
                            </tr>
                        </thead>
                        <tbody>
                            {sentNotifications.map((notification, index) => (
                                <tr key={index}>
                                    <td>{notification.title}</td>
                                    <td>{notification.body}</td>
                                    <td>
                                        {notification.image && (
                                            <img
                                                src={notification.image}
                                                alt="Notification"
                                                style={{ width: "100%", maxWidth: "100px", height: "100px" }}
                                            />
                                        )}
                                    </td>
                                    <td>
                                        {notification.clickUrl && (
                                            <a href={notification.clickUrl} target="_blank" rel="noopener noreferrer">
                                                {notification.clickUrl}
                                            </a>
                                        )}
                                    </td>
                                    <td>{notification.dateTime}</td>
                                    <td>
                                        <button
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleDelete(index)}
                                        >
                                            Delete
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </SuperAdminHeader>
    );
};


export default NotificationHistory;